'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rcCollapse = require('rc-collapse');

var _rcCollapse2 = _interopRequireDefault(_rcCollapse);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AntCollapse = function (_React$Component) {
  _inherits(AntCollapse, _React$Component);

  function AntCollapse() {
    _classCallCheck(this, AntCollapse);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(AntCollapse).apply(this, arguments));
  }

  _createClass(AntCollapse, [{
    key: 'render',
    value: function render() {
      return _react2["default"].createElement(_rcCollapse2["default"], this.props);
    }
  }]);

  return AntCollapse;
}(_react2["default"].Component);

AntCollapse.defaultProps = {
  prefixCls: 'ant-collapse'
};

AntCollapse.Panel = _rcCollapse2["default"].Panel;

exports["default"] = AntCollapse;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/collapse/index.jsx
 ** module id = 445
 ** module chunks = 0
 **/